export default __webpack_public_path__ + "static/media/rocket_anim_40.2b4c10b0.png";